<template>
    <div>
        <v-container class="grid-list-xl px-0">
            <v-row justify="center" align="center" class="h-100">
                <v-col cols="11" class="h-30">
                    <v-row dense no-gutters>
                        <v-col cols="6">
                            <div class="fs-24 gradient5 fi_animate">FI & IOB</div>
                            <div class="fs-100 py-8">{{ $t('tokens.tokens') }}</div>
                            <div class="fs-24 dark-gray--text">{{ $t('tokens.differentFunctional') }}</div>
                            <div class="fs-24 dark-gray--text pb-8">{{ $t('tokens.transactionalAndFinancialFunctions') }}</div>
                            <a href="https://app.uniswap.org/#/swap?use=V2&inputCurrency=ETH&outputCurrency=0xf03d05ed4cf4e723c04500ab64281bfa591968f2" target="_blank" class="del-underline">
                                <v-btn tile class="glow-red text-none gradient-btn-3">{{ $t('tokens.buyFI') }}</v-btn>
                            </a>
                        </v-col>
                        <v-col cols="1"></v-col>
                        <v-col cols="5">
                            <iframe src="https://app.uniswap.org/#/swap?use=V2&theme=dark&outputCurrency=0xf03d05ed4cf4e723c04500ab64281bfa591968f2" height="600px" width="100%" style="border: 0; margin: 0 auto; display: block; border-radius: 0px; max-width: 600px; min-width: 300px;" class="ml-n5 mt-n70" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
            <v-row justify="center" class="mt-16 pt-16">
                <v-col md="6">
                </v-col>
                <v-col md="5" class="fs-24 px-6">
                    <div class="fs-24 gradient5 fi_animate pb-6">{{ $t('tokens.governanceToken') }}</div>
                    <div class="fs-68">
                        FI
                    </div>
                </v-col>
            </v-row>
            <v-row justify="center" class="pt-8 pb-250">
                <v-col md="6" class="text-right fs-24">
                    <div class="pb-6 pr-16"><span class="mr-3">{{ $t('tokens.listing') }}</span> <span class="point-icon-6 animate-point-init animate-point-wave mt-2"></span></div>
                    <div class="fs-18 dark-gray--text pb-8 pr-16 mr-3">{{ $t('tokens.FIWillBeListed') }}</div>
                    <div class="pb-6 pr-16"><span class="mr-3">{{ $t('tokens.staking') }}</span><span class="point-icon-6 animate-point-init animate-point-wave mt-2"></span></div>
                    <div class="fs-18 dark-gray--text pb-8 pr-16 mr-3">{{ $t('tokens.FIOffersVariousStakingRewardRates') }}</div>
                    <div class="pb-6 pr-16"><span class="mr-3">{{ $t('tokens.aligningIncentives') }}</span><span class="point-icon-6 animate-point-init animate-point-wave mt-2"></span></div>
                    <div class="fs-18 dark-gray--text pb-8 pr-16 mr-3">{{ $t('tokens.FIAlignsIncentives') }}</div>
                </v-col>
                <v-col md="5" class="px-6">
                    <div class="fs-18 pb-6">{{ $t('tokens.token') }}:</div>
                    <div class="dark-gray--text pb-6">
                        <span>
                            <logo type="circle" color="w"></logo>
                        </span>
                        <span class="fs-22">
                            FI
                        </span>
                    </div>
                    <div class="fs-18 pb-6">{{ $t('tokens.tokenContractAddress') }}:</div>
                    <div class="fs-18 pb-6 title_txt"><a href="https://etherscan.io/token/0xf03d05ed4cf4e723c04500ab64281bfa591968f2" target="_blank" class="del-underline pure-red--text">0xf03d05ed4cf4e723c04500ab64281bfa591968f2 &#8599;</a></div>
                    <div class="fs-18 dark-gray--text pb-8">{{ $t('tokens.FIIsAGovernanceToken') }}</div>
                    <div class="fs-18 dark-gray--text">{{ $t('tokens.liquidityProvidersInvestors') }}</div>
                    <a href="https://v2.info.uniswap.org/token/0xf03d05ed4cf4e723c04500ab64281bfa591968f2" class="del-underline" target="_blank">
                        <v-btn tile class="text-none mt-16 gradient-btn-3">{{ $t('common.learnMore') }}</v-btn>
                    </a>
                </v-col>
            </v-row>
            <v-row justify="center" class="pt-250 pb-250">
                <v-col md="11" class="fs-24 text-center">{{ $t('tokens.tokenRoadmap') }}</v-col>
                <v-row justify="center" class="mt-150">
                    <v-timeline>
                        <v-timeline-item small color="#2196F3" class="dark-gray--text fs-16">{{ $t('tokens.initialUniswapListing') }}</v-timeline-item>
                        <v-timeline-item small color="#21cbf3" class="text-right dark-gray--text fs-16">{{ $t('tokens.firstTokenAllotment') }}</v-timeline-item>
                        <v-timeline-item small color="#b6dcfb" class="dark-gray--text fs-16">{{ $t('tokens.secondTokenAllotment') }}</v-timeline-item>
                    </v-timeline>
                </v-row>
            </v-row>
        </v-container>
        <div class="bg-gradient-1">
            <v-container>
                <v-row justify="center" class="pt-250 pb-250 pl-11">
                    <v-col cols="6" class="text-right dark-gray--text">
                        <div class="fs-24 gradient5 fi_animate pb-2 pr-16">{{ $t('tokens.earlyInvestorToken') }}</div>
                        <div class="fs-68 pb-8 black--text pr-16">IOB</div>
                        <div class="fs-18 black--text pr-16">{{ $t('tokens.IOBTokenholders') }}</div>
                        <div class="pr-16">
                            <a :href="faq + '/getting-started/faq#iob-token'" class="del-underline" target="_blank">
                                <v-btn tile class="text-none mt-16 gradient-btn-3">{{ $t('common.learnMore') }}</v-btn>
                            </a>
                        </div>
                    </v-col>
                    <v-col cols="6" class="pl-14">
                        <div class="fs-22 black--text pb-6 pt-160"><span class="point-icon-6 animate-point-init animate-point-wave mt-2"></span><span class="pl-9">{{ $t('tokens.ownsFI') }}</span></div>
                        <div class="fs-18 black--text pb-8 pl-9">{{ $t('tokens.initialFITokenSupply') }}</div>
                        <div class="fs-22 black--text pb-6"><span class="point-icon-6 animate-point-init animate-point-wave mt-2"></span><span class="pl-9">{{ $t('tokens.convertibleToFI') }}</span></div>
                        <div class="fs-18 black--text pb-8 pl-9">{{ $t('tokens.IOBTokens') }}</div>
                        <div class="fs-22 black--text pb-6"><span class="point-icon-6 animate-point-init animate-point-wave mt-2"></span><span class="pl-9">{{ $t('tokens.higherEconomicalBenefits') }}</span></div>
                        <div class="fs-18 black--text pb-8 pl-9">{{ $t('tokens.IOBTokenHolders') }}</div>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container class="px-0">
            <v-row justify="center" class="pt-250 pb-500">
                <v-col md="11" class="fs-24 text-center">
                    <div class="fs-24 gradient5 fi_animate">{{ $t('common.nutshell') }}</div>
                    <div class="fs-54 mt-16">{{ $t('tokens.youCanBenefit') }}</div>
                    <a :href="faq + '/getting-started/faq/#what-is-the-exchange-rate-between-iob-and-fi-tokens'" class="del-underline" target="_blank">
                        <v-btn tile class="glow-red text-none mt-16 gradient-btn-3">{{ $t('common.learnMore') }}</v-btn>
                    </a>
                </v-col>
            </v-row>
            <v-row justify="center" class="my-16 text-center pb-100">
                <v-col cols="11" class="py-0 my-0">
                    <a href="https://poweredby.aragon.org/" class="del-underline" target="_blank">
                        <logo type="aragon" color="aragon"></logo>
                    </a>
                </v-col>
                <v-col cols="8" class="fs-14 dark-gray--text">
                    {{ $t('tokens.digitalAssetsCanBeVolatileAndRisky') }}
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<style>
</style>
<script>
import Vue from 'vue';
import config from '@/config';
import Logo from '@/components/common/Logo';

export default {
    data() {
        return {
            fi: config.domainName,
            faq: config.faq
        }
    },
    created() {},
    mounted() {

    },
    computed: {

    },
    components: {
        Logo
    },
    watch: {

    },
    methods: {},
}
</script>
